/* Header (simple) — drawer, sub-panels, desktop dropdown a11y, search, cart count mirror */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
    var header = document.querySelector('[data-header-simple]');
    if (!header) return;

    var drawer = document.getElementById('mobNavDrawer');
    var drawBg = document.getElementById('drawBg');
    var openers = header.querySelectorAll('.js-hs-drawer-open');
    var closers = header.querySelectorAll('.js-hs-drawer-close');
    var lastFocused = null;

    /* ---------- Drawer open / close ---------- */
    function openDrawer(trigger) {
      if (!drawer) return;
      lastFocused = trigger || document.activeElement;
      drawer.classList.add('open');
      if (drawBg) drawBg.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      // Move focus into the dialog container (not the close button) so screen
      // readers enter the modal without a heavy focus ring on the X (design has none).
      if (!drawer.hasAttribute('tabindex')) drawer.setAttribute('tabindex', '-1');
      drawer.focus();
    }

    function closeDrawer() {
      if (!drawer) return;
      resetSubpanels();
      drawer.classList.remove('open');
      if (drawBg) drawBg.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', function () { openDrawer(btn); });
    });
    closers.forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });

    /* ---------- Sliding sub-panels ---------- */
    // Sub-panels are position:fixed, but the drawer's transform makes them
    // resolve against the (scrollable) drawer box — so if the drawer is scrolled
    // the panel ends up offset (back button hidden, list shows through). Pin the
    // drawer to the top while a sub-panel is open and restore the scroll on back.
    var subpanelSavedScroll = 0;

    function resetSubpanels() {
      if (!drawer) return;
      drawer.classList.remove('hs-subpanel-active');
      drawer.querySelectorAll('.hs-drawer__subpanel.is-active').forEach(function (p) {
        p.classList.remove('is-active');
        p.setAttribute('aria-hidden', 'true');
      });
      drawer.querySelectorAll('.js-hs-subpanel-open[aria-expanded="true"]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      drawer.scrollTop = subpanelSavedScroll;
    }

    if (drawer) {
      drawer.querySelectorAll('.js-hs-subpanel-open').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var panel = btn.nextElementSibling;
          if (!panel || !panel.classList.contains('hs-drawer__subpanel')) return;
          var currentScroll = drawer.scrollTop; // remember where the user was
          resetSubpanels();
          subpanelSavedScroll = currentScroll;
          panel.classList.add('is-active');
          panel.setAttribute('aria-hidden', 'false');
          btn.setAttribute('aria-expanded', 'true');
          drawer.classList.add('hs-subpanel-active');
          drawer.scrollTop = 0; // pin the sub-panel to the top of the viewport
          // Move focus into the sub-panel container (not the back button) so it
          // enters the panel for screen readers without a heavy focus ring on tap.
          if (!panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');
          panel.focus({ preventScroll: true });
        });
      });

      drawer.querySelectorAll('.js-hs-subpanel-back').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var panel = btn.closest('.hs-drawer__subpanel');
          resetSubpanels();
          if (panel) {
            var opener = panel.previousElementSibling;
            if (opener && opener.classList.contains('js-hs-subpanel-open')) opener.focus({ preventScroll: true });
          }
        });
      });
    }

    /* ---------- ESC ---------- */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (drawer && drawer.classList.contains('open')) {
        if (drawer.classList.contains('hs-subpanel-active')) {
          resetSubpanels();
        } else {
          closeDrawer();
        }
      }
      var searchDrawer = document.getElementById('hsSearchDrawer');
      if (searchDrawer && searchDrawer.classList.contains('open')) closeSearch();
    });

    /* ---------- Search ---------- */
    var searchBtn = document.getElementById('searchButton');
    var searchDrawer = document.getElementById('hsSearchDrawer');
    var searchBg = document.getElementById('hsSearchBg');
    var searchClose = document.getElementById('hsSearchClose');
    var searchInput = document.getElementById('hs-search-input');

    function openSearch() {
      if (!searchDrawer) return;
      searchDrawer.classList.add('open');
      if (searchBg) searchBg.classList.add('open');
      if (searchInput) searchInput.focus();
    }

    function closeSearch() {
      if (!searchDrawer) return;
      searchDrawer.classList.remove('open');
      if (searchBg) searchBg.classList.remove('open');
      if (searchInput) searchInput.blur();
    }

    if (searchBtn) searchBtn.addEventListener('click', openSearch);
    if (searchClose) searchClose.addEventListener('click', closeSearch);
    if (searchBg) searchBg.addEventListener('click', closeSearch);

    // mobile / drawer search buttons delegate to the canonical desktop search trigger
    header.querySelectorAll('.js-hs-search-open').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (drawer && drawer.classList.contains('open')) closeDrawer();
        openSearch();
      });
    });

    // Auto-dismiss the search:
    // 1) hovering a dropdown nav item (the mega-menu would otherwise overlap it)
    header.querySelectorAll('.hs-desktop__nav-item--has-dd').forEach(function (item) {
      item.addEventListener('mouseenter', closeSearch);
    });
    // 2) clicking any top-level nav link
    header.querySelectorAll('.hs-desktop__nav-link').forEach(function (link) {
      link.addEventListener('click', closeSearch);
    });
    // 3) clicking anywhere outside the open search (the search button keeps it open)
    document.addEventListener('click', function (e) {
      if (!searchDrawer || !searchDrawer.classList.contains('open')) return;
      if (searchDrawer.contains(e.target)) return;
      if (e.target.closest('#searchButton') || e.target.closest('.js-hs-search-open')) return;
      closeSearch();
    });

    /* ---------- Cart: delegate non-canonical cart buttons to #cart-link ---------- */
    var cartLink = document.getElementById('cart-link');
    header.querySelectorAll('.js-hs-cart-open').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (!cartLink) return; // fall through to plain /cart navigation
        e.preventDefault();
        if (drawer && drawer.classList.contains('open')) closeDrawer();
        cartLink.click();
      });
    });

    /* ---------- Cart count: red dot indicator + mirror count to all bags ----------
       Reads the canonical count from #cart-icon-bubble's text (works for the
       initial Liquid render AND the cart-icon-bubble section re-render that
       cart-drawer.js injects after add/update). Toggles .hs-cart--has-items
       (the red dot) on every cart control and mirrors the number for SR. */
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) {
      var carts = header.querySelectorAll('.hs-cart');
      var syncCart = function () {
        var count = parseInt((bubble.textContent || '').replace(/[^0-9]/g, ''), 10) || 0;
        carts.forEach(function (c) {
          c.classList.toggle('hs-cart--has-items', count > 0);
        });
        header.querySelectorAll('[data-cart-count]').forEach(function (node) {
          if (bubble.contains(node)) return;
          node.textContent = count;
        });
      };
      syncCart();
      new MutationObserver(syncCart).observe(bubble, { childList: true, subtree: true, characterData: true });
    }

    /* ---------- Desktop dropdown keyboard a11y ---------- */
    header.querySelectorAll('.hs-desktop__nav-item--has-dd').forEach(function (item) {
      var trigger = item.querySelector('.hs-desktop__nav-link');
      var panel = item.querySelector('[data-dd-panel]');
      if (!trigger || !panel) return;

      item.addEventListener('focusin', function () {
        trigger.setAttribute('aria-expanded', 'true');
      });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) {
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          trigger.setAttribute('aria-expanded', 'false');
          trigger.blur();
        }
      });
    });
  });
})();
